import { LoadableAfterPaint } from '@confluence/loadable';

export { ANALYTICS_SOURCE } from '../src/BulkSpacePermissionsPage.tsx';

export const BulkSpacePermissionsPortal = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BulkSpacePermissionsPortal" */ '../src/BulkSpacePermissionsPortal.tsx'
			)
		).BulkSpacePermissionsPortal,
	name: 'BulkSpacePermissionsPortal',
});

export const BulkSpacePermissionsPage = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BulkSpacePermissionsPage" */ '../src/BulkSpacePermissionsPage.tsx'
			)
		).BulkSpacePermissionsPage,
	name: 'BulkSpacePermissionsPage',
});
